import { useMutation } from "@tanstack/react-query";
import axios from "axios";
import { queryClient } from "client";
import { useUserAuth } from "context/authProvider";
import axiosInstance from "utils/axios";
import { clearAllLocalStorage } from "utils/utility";

export const activateKey = async (key) => {
  return axiosInstance
    .post("keys/activate", { key: key })
    .then((response) => response.data)
    .catch((error) => error.response.data);
};

export const checkTenant = async () => {
  return axiosInstance
    .get(`institute/checkTenant`)
    .then((response) => response.data)
    .catch((error) => {
      return error.response.data;
    });
};

const logout = async () => {
  return axiosInstance
    .post("users/logout")
    .then((response) => response.data)
    .catch((error) => error.response.data);
};

export const useUserLogout = () => {
  const { setUser } = useUserAuth();
  return useMutation({
    mutationKey: "logout",
    mutationFn: logout,
    onSuccess: () => {
      setUser(null);
      clearAllLocalStorage();
      queryClient.invalidateQueries();
      window.location.href = "/user-auth/login";
    },
  });
};

export async function switchSession({ id, session_id, token }) {
  return axiosInstance
    .post(
      "users/switch-session",
      { id, session_id },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      }
    )
    .then((res) => res.data);
}

export const getUserGeoDetails = async () => {
  return axios.get(process.env.REACT_APP_SERVER_URL).then((res) => res.json());
};

export async function updateUserVisit() {
  return axiosInstance.post("users/updateUserVisit").then((res) => res.data);
}
